if (!window.customElements.get('accordions-section')) {
  class AccordionsSection extends HTMLElement {
    constructor() {
      super();
      this.accordions = this.querySelectorAll('[data-accordion]');
      this.truncateButton = this.querySelector('[data-truncate-button]');
      this.threshold = this.truncateButton ? parseInt(this.truncateButton.getAttribute('data-threshold')) : null;
      this.mobileThreshold = this.truncateButton ? parseInt(this.truncateButton.getAttribute('data-mobile-threshold')) : null;
    }

    connectedCallback() {
      if (this.truncateButton) {
        this.truncateButton.addEventListener('click', () => this.toggleAccordions());
      }
    }

    toggleAccordions() {
      if (this.truncateButton.classList.contains('active')) {
        this.truncateButton.classList.remove('active');
        this.truncateButton.setAttribute('aria-expanded', 'false');

        this.accordions.forEach((accordion, index) => {
          if (index >= this.threshold) {
            accordion.classList.add('lg:hidden');
          }

          if (index >= this.mobileThreshold) {
            accordion.classList.add('max-lg:hidden');
          }
        });
      } else {
        this.truncateButton.classList.add('active');
        this.truncateButton.setAttribute('aria-expanded', 'true');
        this.accordions.forEach((accordion) => {
          accordion.classList.remove('lg:hidden', 'max-lg:hidden');
        });
      }
    }
  }

  window.customElements.define('accordions-section', AccordionsSection);
}